import { gql, useLazyQuery } from '@apollo/client';
import { omit } from 'lodash';
import { useCallback } from 'react';

import { translateInput } from '@work4all/data/lib/hooks/data-provider/useDataMutation';

import { TravelAdditionalMealExpenses } from '@work4all/models/lib/Classes/TravelAdditionalMealExpenses.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

const CALCULATE_TRAVEL_EXPENSES = gql`
  query calculateTravelExpenses($input: InputReisekostenabrechnung!) {
    calculateTravelExpenses(input: $input) {
      id: code
      additionalMealExpenses {
        code
        travelExpensesId: reisekostenabrechnungCode
        dateTime
        amount
        hours
        deductionBreakfast
        deductionBreakfastAmount
        deductionLunch
        deductionLunchAmount
        deductionDinner
        deductionDinnerAmount
        note
        businessPartnerId: sdObjMemberCode
        businessPartnerType: sdObjType
        projectId: projectCode
        project {
          id: code
          name
          number: nummer
        }
        company {
          id: code
          data: data {
            ... on Kunde {
              id: code
              name: name
            }
            ... on Lieferant {
              id: code
              name: name
            }
          }
        }
      }
    }
  }
`;

export const useCalculateTravelExpenses = () => {
  const [calculateTravelExpensesQuery] = useLazyQuery(
    CALCULATE_TRAVEL_EXPENSES
  );

  const calculate = useCallback(
    async (input: Record<string, unknown>) => {
      const translatedInput = translateInput(
        Entities.travelExpenses,
        input,
        false
      );

      return await calculateTravelExpensesQuery({
        variables: {
          input: {
            ...translatedInput,
            additionalMealExpenses: (
              (input.additionalMealExpenses as TravelAdditionalMealExpenses[]) ??
              []
            )
              .map((x) => omit(x, '__typename', 'hours'))
              .map((x) =>
                translateInput(Entities.travelAdditionalMealExpenses, x, false)
              ),
          },
        },
      });
    },
    [calculateTravelExpensesQuery]
  );

  return calculate;
};
